import { Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'

import GalleryImage from 'images/ecom/virtual-gallery/countdown/gallery.png'

export const Wrapper = styled('div')(({ theme, withImage }) => ({
  backgroundColor: theme.colors.violet[300],
  border: `1px solid ${theme.colors.violet[500]}`,
  borderRadius: '4px',
  padding: '20px 20px 24px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '382px',
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      padding: '16px',
      flexDirection: 'row',
      alignItems: 'stretch',
      maxWidth: '640px',
      width: '100%',
      gap: '20px',
    },
    [theme.breakpoints.up(1640)]: {
      maxHeight: '152px',
    },
    [theme.breakpoints.up('xl')]: {
      justifyContent: 'space-between',
    },
  }),
}))

export const Image = styled('div')(({ theme, imageUrl }) => ({
  width: '100%',
  height: '140px',
  borderRadius: '4px',
  background: `url(${imageUrl || GalleryImage}) no-repeat`,
  backgroundSize: 'cover',
  backgroundPosition: '20% 50%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '130px',
    height: 'auto',
  },
  [theme.breakpoints.up(1640)]: {
    maxWidth: '100px',
  },
}))

export const DescriptionWrapper = styled('div')(({ theme, withImage }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '12px',
      width: 'auto',
    },
    [theme.breakpoints.up(1640)]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
  }),
  [theme.breakpoints.up('xl')]: {
    gap: withImage ? '20px' : '40px',
    flexDirection: 'row',
    alignItems: 'center',
  },
}))

export const InfoBox = styled('div')(({ theme, withImage }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      flexDirection: 'column',
      gap: 0,
      alignItems: 'flex-start',
    },
  }),
}))

export const TextBox = styled('div')(({ theme, withImage }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  }),
}))

export const CountdownWrapper = styled('div')(({ theme, withImage }) => ({
  display: 'flex',
  width: '100%',
  marginTop: withImage ? '16px' : 0,
  marginBottom: '16px',
  justifyContent: 'center',
  position: 'relative',
  '&::after, &:before': {
    content: '""',
    position: 'absolute',
    top: 14,
    height: '1px',
    width: '108px',
    backgroundColor: theme.colors.violet[500],
  },
  '&::before': {
    left: -20,
  },
  '&::after': {
    right: -20,
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    marginTop: 0,
    marginBottom: '10px',
    '&::after, &:before': {
      display: 'none',
    },
  },
}))

export const TitleText = styled(Typography)(({ theme, withImage }) => ({
  color: theme.colors.dark,
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: 1.4,
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      fontSize: '1.375rem',
      lineHeight: 1.2,
      marginBottom: '6px',
    },
  }),
}))

export const AdditionalText = styled(Typography)({
  color: '#1E202B',
  fontSize: '0.75rem',
  fontWeight: 700,
  lineHeight: 1.4,
  textTransform: 'uppercase',
  marginBottom: '4px',
})

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.colors.grey[700],
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: 1.5,
  [theme.breakpoints.up('md')]: {
    lineHeight: 1.4,
    marginTop: '2px',
  },
}))

export const ButtonWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
})

export const StyledTrackButton = styled(TrackButton)(({ theme, withImage }) => ({
  maxWidth: '180px',
  padding: '12px 42px',
  marginTop: withImage ? '20px' : '12px',
  whiteSpace: 'nowrap',
  ...(withImage && {
    [theme.breakpoints.up('md')]: {
      maxWidth: '160px',
      padding: '12px 32px',
      marginTop: 0,
    },
  }),
}))
